/**
 *
 * MobileTeacherHeader
 *
 */

import React, { memo, useState, useRef, useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

// styles
import './style.scss';

// antd component
import { Button, List, Empty, Drawer } from 'antd';
import { NavBar } from 'antd-mobile';

// assets
import { MenuOutlined, PlusOutlined } from '@ant-design/icons';
import CustomIcons from 'components/CustomIcons';

// components
import SchoolPreview from 'mobile/components/SchoolPreview';

import history from 'utils/history';

// global user
import {
  withUser,
  useGetUserSchools,
 // useChangeChildByID,
  useGetLocalUser,
  useGetLocalActiveSchool
} from 'engine/Contexts/User.context';

import { useAuthRole } from 'utils/hooks';

function MobileTeacherHeader({
  visibility,
  collapse,
  roles,
  user,
  hideForPath,
  // default props
  className,
}) {
  
  const localUser = useGetLocalUser()();
  const activeSchool = useGetLocalActiveSchool()();
  const userSchools = useGetUserSchools()();
  //const changeSchoolByID = useChangeSchoolByID();

  const roleClass = localUser?.role ? localUser?.role : '';

  const containerRef = useRef(null);
  const activeItemRef = useRef(null);

  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [maxScrollPosition, setMaxScrollPosition] = useState(1);
  const [isDragging, setIsDragging] = useState(false);
  const [loading, setLoading] = useState(false);

  const MIN_DISTANCE = 5;
  const CONTAINER_PADDING = 15;
  const CONTAINER_SCROLL_STEP = 100;

  const childClassNames = classNames(
    'layout-header-teacher',
    roleClass,
    className,
  );

  // If pathname is changes than we scroll to the active list item
  useEffect(() => {
    if (!!containerRef?.current && !!activeItemRef?.current) {
      containerRef.current.scrollTo({
        left: activeItemRef?.current?.offsetLeft - CONTAINER_PADDING,
        behavior: "smooth",
      });
    }
  }, [history?.location?.pathname]);

  // Init scrollbar container and set max positin for scrolling
  useEffect(() => {
    if (!!containerRef?.current) {
      setMaxScrollPosition(
        containerRef?.current?.scrollWidth - containerRef?.current?.clientWidth
      );
      return () => {
        setIsDragging(false);
      }
    } 
  }, [containerRef]);

  useEffect(() => {
    setIsDragging(loading);
  }, [loading]);

  const onMountedItemList = useCallback((ref) => {
    activeItemRef.current = ref?.current || null;
    if (!!containerRef?.current && !!ref?.current && !isDragging) {
      containerRef.current.scrollTo({
        left: ref?.current?.offsetLeft - CONTAINER_PADDING,
        behavior: "smooth",
      });
    }
  }, [activeItemRef, isDragging]);

  const handleContainerScroll = (e) => {
    setIsDragging(true);
    setScrollPosition(e.target.scrollLeft);
    setMaxScrollPosition(
      e.target.scrollWidth - e.target.clientWidth
    );
  };

  const handleSchoolClick = async (schoolID, index) => {
  /*   const result = await changeSchoolByID(schoolID);
    !!result && setLoading(false); */
    setLoading(false)
  };
  

  const handleTouchStart = (e) => {
    setIsDragging(false);
    const touchStart = e.touches[0].clientX;
    setTouchStartX(touchStart);
  };
  
  const handleTouchMove = (e) => {
    setIsDragging(true);
    const touchEnd = e.touches[0].clientX;
    setTouchEndX(touchEnd);
  };
  
  const handleTouchEnd = (e) => {
    
   // const distance = e.changedTouches[0].clientX - touchStartX;
    const distance = touchEndX - touchStartX;
    if (distance < MIN_DISTANCE ) {
      // click
      // console.log("Click", isDragging, distance);
    } else {
      // swipe
      // console.log("Swipe", isDragging, distance);
      if (distance > 0) {
        !!containerRef?.current && containerRef?.current.scrollTo({
          left: scrollPosition - CONTAINER_SCROLL_STEP,
          behavior: "smooth",
        });
      } else {
        !!containerRef?.current && containerRef?.current.scrollTo({
          left: scrollPosition + CONTAINER_SCROLL_STEP,
          behavior: "smooth",
        });
      }
      setIsDragging(false);
    }
  };

  
  const handleArrowClick = (direction) => {
    setIsDragging(true);
    if (direction === 'left') {
      !!containerRef?.current && containerRef?.current.scrollTo({
        left: scrollPosition - CONTAINER_SCROLL_STEP,
        behavior: "smooth",
      });
    } else {
      !!containerRef?.current && containerRef?.current.scrollTo({
        left: scrollPosition + CONTAINER_SCROLL_STEP,
        behavior: "smooth",
      });
    }
    setIsDragging(false);
  };

  // check if open page for online
  // if detail page => is on open page except community detail page
  const isPublicPath = useCallback(() => {
    const pathname = window.location.pathname;
    const isPath = hideForPath?.some(p => pathname.includes(p));
    if (!!isPath) {
      return true;
    } else {
      return false;
    }
  }, []);

  const addNewSchool = useMemo(() => (
    <div
      className="add-new-school"
    >
      <PlusOutlined />
    </div>
  ), []);

  const renderList = useMemo(() => {
    const schoolAct = user?.activeSchool || activeSchool;
    return !!userSchools ? (
      <div
        className="mobile-school-menu"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onScroll={handleContainerScroll}
        ref={containerRef}
      >
        {userSchools?.map((school, index) => {
          return (
            <SchoolPreview
              key={`side-menu-std-info-${school?._id}`}
              view="small"
              loading={loading}
              isActive={school?._id == schoolAct?._id}
              school={school}
              showChangeButton={false}
              onClick={() => { 
                setLoading(true);
                handleSchoolClick(school?._id, index)
              }}
              onMount={(ref) => onMountedItemList(ref)}
            />
          );
        })}
        {addNewSchool}
      </div>
    ) : (
      <div className="mobile-school-menu" ref={containerRef}>
        {addNewSchool}
      </div>
    );
  }, [user?.activeSchool, activeSchool, user?.schools, userSchools, containerRef]);

  return !!useAuthRole(roles) && visibility && !isPublicPath() && (
    <div className={classNames(
      collapse && 'collapsed',
      loading && 'loading',
      childClassNames
    )}>
      {/* <span
        className={classNames(
          "horizontal-menu-arrow left",
          scrollPosition === 0 && 'hide'
        )}
        onClick={() => handleArrowClick('left')}></span> */}
    
      {renderList}

     {/*  <span
        className={classNames(
          "horizontal-menu-arrow right",
          scrollPosition === maxScrollPosition && "hide"
        )}
        onClick={() => handleArrowClick('right')}></span> */}
    </div>
  );
}

MobileTeacherHeader.defaultProps = {
  visibility: true,
  collapse: false,
  roles: ["teacher"],
  hideForPath: ['/signupparent', '/reset', '/confirm', '/login']
};
MobileTeacherHeader.propTypes = {};

export default compose(
  withUser,
)(MobileTeacherHeader);
